import React from 'react';
import isEmpty from 'lodash/isEmpty';
import ImageComponent from 'atoms/Image';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import PropTypes from 'prop-types';

const BrandComponentContainer = ({ brandData }) => {
  return (
    <>
      {!isEmpty(brandData) && (
        <div className='banner-component-container grid-container' data-testid='banner-component-container'>
          <div className='brand-headline'>{brandData?.headLine}</div>
          <div className='banner-component-section'>
            <div className='icon-section'>
              {brandData?.dispositions?.map(disposition => {
                return (
                  <div
                    className={`icon-wrapper ${disposition.class}`}
                    key={disposition.key}
                    data-testid={disposition.class}
                  >
                    <ImageComponent srcFile={disposition?.url} />
                    <div className='icon-title'>{disposition?.category}</div>
                  </div>
                );
              })}
            </div>
            {brandData?.cta && (
              <ContainedButton
                aria-label={brandData.cta.label}
                id='find-more'
                data-testid='find-more'
                className='find-more-btn'
                variant={ButtonType.secondary}
              >
                <a href={brandData.cta.url}>{brandData.cta.label}</a>
              </ContainedButton>
            )}
          </div>
        </div>
      )}
    </>
  );
};

BrandComponentContainer.propTypes = {
  brandData: PropTypes.object.isRequired,
};

BrandComponentContainer.defaultProps = {};

export default BrandComponentContainer;
